import React from "react";
import { Button } from "react-bootstrap";

function PaginationTab({ pagination, page, setPage, content }) {
  const { totalPages } = pagination;
  const itemsPerPage = localStorage.getItem("paginationConfig");

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const visiblePages = page === 1 ? 4 : page === 2 ? 3 : 2;

    const startPage = Math.max(1, page - visiblePages);
    const endPage = Math.min(totalPages, page + visiblePages);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li className={`page-item ${page === i && "active"}`} key={i}>
          <button onClick={() => setPage(i)} size="sm" className="page-link">
            {i}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  const startItem = (page - 1) * itemsPerPage + 1;
  const lastItem = Math.min(page * itemsPerPage, pagination.totalItems);

  return (
    <>
      <nav className="right-0 d-flex justify-content-end gap-4 align-items-center">
        <div className="pagination-summary fw-bold  mb-3">{`${startItem} - ${lastItem} of ${pagination.totalItems}`}</div>
        <ul className="pagination">
          <li className={`page-item ${page === 1 && "disabled"} `}>
            <button onClick={() => setPage(1)} className="page-link">
              &lt;&lt;
            </button>
          </li>
          <li className={`page-item ${page === 1 && "disabled"}`}>
            <button onClick={() => setPage(page - 1)} className="page-link">
              &lt;
            </button>
          </li>

          {renderPageNumbers()}

          <li className={`page-item ${page === totalPages && "disabled"}`}>
            <button onClick={() => setPage(page + 1)} className="page-link">
              &gt;
            </button>
          </li>
          <li className={`page-item ${page === totalPages && "disabled"}`}>
            <Button onClick={() => setPage(totalPages)} className="page-link">
              &gt;&gt;
            </Button>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default PaginationTab;
